import React from "react";
import PrimeReact from "primereact/api";
import { Routes, Route } from "react-router-dom";
import TrackingModule from "./TrackingModule";
import NotFound from "./NotFound";
import AdminModule from "./AdminModule";

const App = () => {
    PrimeReact.ripple = true;
    return (
        <Routes>
            <Route path="/order" element={<TrackingModule />} />
            <Route path="/admin" element={<AdminModule />} />
            <Route path="/" element={<NotFound />} />
        </Routes>
    );
};

export default App;
